export default __webpack_public_path__ + "static/media/kreativno-razmisluvanje.6335da2a.gif";